import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";

export const AccountStatementTransactionDropdown = observer(
	function AccountStatementTransactionDropdown() {
		const store = useAccountStatementStore();
		const t = useTranslation().t;

		const getTransactionTableArray = () => {
			const showAllTypes = {
				abrv: "all",
				name: t("ACC_STATEMENT.FILTER.SHOW_ALL_TRANSACTION_TYPES"),
			};

			if (!store.transactionLookup) {
				return [showAllTypes];
			}

			const transactionTypesPerWallet = store.transactionLookup;
			return [
				showAllTypes,
				...(transactionTypesPerWallet?.transactionTypes || []),
			];
		};

		let data = getTransactionTableArray();

		return (
			<FormSelectField
				disabled={!store.transactionLookup}
				className="form__group"
				label="ACC_STATEMENT.FILTER.AS_TYPE"
				name="asType"
				keyValue="abrv"
				dropdownData={data}
			/>
		);
	}
);
